// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3rE1o","checkboxCol":"Table_checkboxCol__32oWg","emailCol":"Table_emailCol__2hAlW","actionCol":"Table_actionCol__2mIrH"};